import '.e{flex-shrink:0;}.ssr-plugin'
import '.k{padding:1rem;}.ssr-plugin'
import '.h{width:100%;}.ssr-plugin'
import '.c7{height:100%;}.ssr-plugin'
import '.by{border:none;}.ssr-plugin'
import '.bz{background-color:transparent;}.ssr-plugin'
import '.fd{border-radius:0px;}.ssr-plugin'
import '.l{display:flex;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.b2{align-items:stretch;}.ssr-plugin'
import '.ea{position:sticky;}.ssr-plugin'
import '.fe{top:4rem;}.ssr-plugin'
import '.ff{z-index:7;}.ssr-plugin'
import '.b5{background-color:var(--palette-white);}.ssr-plugin'
import '.fg{padding-bottom:1rem;}.ssr-plugin'
import '.al{margin-bottom:1rem;}.ssr-plugin'
import '.fh{border-bottom:var(--border-subtle);}.ssr-plugin'
import '.as{position:fixed;}.ssr-plugin'
import '.cz{top:0;}.ssr-plugin'
import '.c5{left:0px;}.ssr-plugin'
import '.c6{right:0px;}.ssr-plugin'
import '.fi{bottom:0px;}.ssr-plugin'
import '.fj{z-index:9999;}.ssr-plugin'
import '.fk{transition:transform 0.3s ease-in-out;}.ssr-plugin'
import '.dh{justify-content:flex-end;}.ssr-plugin'
import '.ch{flex:1;}.ssr-plugin'
import '.ba{overflow-y:auto;}.ssr-plugin'
import { Style, styled } from 'inlines'
import {
  isValidElement,
  PropsWithChildren,
  ReactNode,
  useState,
  useEffect,
} from 'react'
import { useLocation } from 'wouter'
import { Button } from '@app/components/core/button/Button'
import { CloseButton } from '@app/components/core/button/CloseButton'

interface LeftSidebarMobileProps {
  sidebar: ReactNode
  content: ReactNode[]
}

const Sidebar = ({
  children,
  style,
}: PropsWithChildren & { style?: Style }) => {
  return (
    <styled.aside className="e k h c7 by bz fd"
      style={{
        ...style,
      }}
    >
      {children}
    </styled.aside>
  )
}

export const LeftSidebarMobile = ({
  sidebar,
  content,
}: LeftSidebarMobileProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const [location] = useLocation()

  // Close sidebar when route changes
  useEffect(() => {
    setIsOpen(false)
  }, [location])

  const collapsedButtonLabel =
    (isValidElement(sidebar) && sidebar.props.collapsedButtonLabel) || 'Menu'

  const sidebarContent = isValidElement(sidebar) ? sidebar.props.children : null
  const sidebarStyle = isValidElement(sidebar) ? sidebar.props.style : undefined

  return (
    <div className="l m b2"
    >
      <div className="ea fe ff b5 fg al fh l"
      >
        <Button
          variant="link"
          label={collapsedButtonLabel}
          onClick={() => setIsOpen(true)}
        />
      </div>

      <div className="as cz c5 c6 fi fj b5 fk l m"
        style={{
          transform: isOpen ? 'translateX(0)' : 'translateX(-100%)',}}
      >
        <div className="k l dh fh"
        >
          <CloseButton onClick={() => setIsOpen(false)} />
        </div>
        <div className="ch ba">
          <Sidebar style={sidebarStyle}>{sidebarContent}</Sidebar>
        </div>
      </div>

      {content}
    </div>
  )
}
